import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {DefaultBtn} from "Ncontracts.Common.UI";
import {imageCdnUrls} from "./ImageCdnUrls";

class SuccessConfirmation extends Component {

    static propTypes = {
        closeModal: PropTypes.func,
        text: PropTypes.string
    };

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="modal is-active alert-modal">
                <div className="modal-background"/>
                <div className="modal-card modal-content">
                    <section className="modal-card-body">
                        <div className="alert-image has-text-centered">
                            <img src={imageCdnUrls.checkmark_circle} width="50" height="50"/>
                        </div>
                        <div className="alert-message has-text-centered">{this.props.text}</div>
                    </section>
                    <footer className="modal-card-foot">
                        <div className="modal-footer-buttons has-text-centered">
                            <DefaultBtn onClick={this.props.closeModal} className="btn--smaller btn--wide">OK</DefaultBtn>
                        </div>
                    </footer>
                </div>
            </div>);
    }
}

export default SuccessConfirmation;
